import * as React from 'react';
import { buildClassString } from '@ps/payscale-shared-ui/lib/StringUtils';
import { killEvent } from 'utils/domUtils';
import './tabSelector.scss';

interface TabSelectorProps {
    items: string[];                         // items to display in tabs
    currentItem: string;                     // item to display as selected
    onItemSelect?: (item: string) => void;    // callback to trigger on user selection
}

interface TabSelectorState {
    selectedItem: string;                    // current item to show as selected
}

class TabSelector extends React.PureComponent<TabSelectorProps, TabSelectorState> {
    constructor(props: TabSelectorProps) {
        super(props);
        this.state = Object.assign({}, this.state, { selectedItem: ''});
    }

    // When we get new propsl we'll want to overwrite state with the
    // current item passed in, vs our stored selected item
    UNSAFE_componentWillReceiveProps(nextProps: TabSelectorProps): void {
        if (!nextProps || !nextProps.currentItem) {
            return;
        }

        this.setState({
            selectedItem: nextProps.currentItem
        });
    }

    render(): React.ReactNode {
        const { items } = this.props;
        const { selectedItem } = this.state;

        if (!items || items.length === 0) {
            return null;
        }

        return (
            <ul className="tab-selector">
                {items.map(item => this._renderItem(item, selectedItem))}
            </ul>
        );
    }

    private _renderItem(item: string, selectedItem: string): React.ReactNode {
        const classString = buildClassString({
            'tab-selector__tab-link': true,
            'selected': item === selectedItem
        });

        return (
            <li className="tab-selector__tab" key={item}>
                <a
                    href="#"
                    className={classString}
                    // tslint:disable-next-line jsx-no-lambda
                    onClick={(e) => {
                        killEvent(e);
                        this._onItemSelect(item);
                    }}
                >
                    {item}
                </a>
            </li>
        );
    }

    private _onItemSelect(item: string): void {
        const { onItemSelect } = this.props;
        const { selectedItem } = this.state;

        if (item === selectedItem) {
            // already selected...no-op
            return;
        }

        this.setState({
            selectedItem: item
        });

        if (onItemSelect) {
            onItemSelect(item);
        }
    }
}

export { TabSelector };
export default TabSelector;



// WEBPACK FOOTER //
// ./src/components/common/tabSelector.tsx